var map = {
	"./ballon.svg": "5136",
	"./barcode.svg": "c72c",
	"./bnb.svg": "2eb7",
	"./brl.svg": "4348",
	"./btc.svg": "96fb",
	"./eth.svg": "ecef",
	"./ezzebank-white.svg": "bc62",
	"./indisponivel.svg": "1d74",
	"./pix.svg": "9037",
	"./pol.svg": "bf10",
	"./trx.svg": "89a7",
	"./usdc.svg": "704f",
	"./usdt.svg": "8410"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";